export interface MatomoSettings {
  tracking: boolean;
  url: string;
  siteID: string;
}

function init({ tracking, url, siteID }: MatomoSettings) {
  if (!tracking) {
    return;
  }
  // self._paq wird von Matomo vorausgesetzt als Event-Queue
  // Es gibt zwei Möglichkeiten in Matomo zu tracken: _paq und _mtm.
  // _pag ist einfacher, _mtm verlangt, dass jedes Event im Tracking Manager konfiguriert wird
  let _paq = (window["_paq"] = window["_paq"] ?? []);
  _paq.push(["setDoNotTrack", true]);
  _paq.push(["disableCookies"]);
  _paq.push(["trackPageView"]);
  _paq.push(["enableLinkTracking"]);
  _paq.push(["setTrackerUrl", url + "matomo.php"]);
  _paq.push(["setSiteId", siteID]);
  const script = document.createElement("script");
  script.async = true;
  script.src = url + "matomo.js";
  const lastScript = document.getElementsByTagName("script")[0];
  lastScript.parentNode.insertBefore(script, lastScript);
}
function event(
  category: string,
  action: string,
  name: string = undefined,
  value: string = undefined,
) {
  const _paq = self["_paq"];
  if (!_paq) return;
  const array = ["trackEvent", category ?? "null", action ?? "null"];
  if (name !== undefined) {
    array.push(name);
  }
  if (value !== undefined) {
    array.push(value);
  }
  _paq.push(array);
  // console.log(array);
}

function page(pageUrl: string, pageTitle: string) {
  const _paq = self["_paq"];
  if (!_paq) return;
  _paq.push(["setCustomUrl", pageUrl]);
  _paq.push(["setDocumentTitle", pageTitle]);
  _paq.push(["trackPageView"]);
}

function registerTrackingErrorHandler() {
  const oldErrorHandler = self.onerror;
  self.onerror = errorHandler;

  function errorHandler(message, javascriptSourceFileUrl, lineNumber, columnNumber, errorObject) {
    event("Fehler", message.substring(0, 100), errorObject?.stack?.substring(0, 150) || message);
    oldErrorHandler(message, javascriptSourceFileUrl, lineNumber, columnNumber, errorObject);
  }
}

export default {
  init,
  event,
  page,
  registerTrackingErrorHandler,
};
